import { useCallback, useEffect, useState } from 'react';

import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { deserializer } from '../../../../shared/utils/deserializer';
import { SUCCESS_MESSAGES } from '../constants';
import {
  cancelSubscription as apiCancelSubscription,
  fetchAccount as apiFetchAccount,
  resumeSubscription as apiResumeSubscription,
} from '../services/accountService';

const useBilling = () => {
  const [account, setAccount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cancelSubscription = useCallback(async () => {
    // Errors are handled in the CancelMenu Dialog component. Errors are shown in an
    // Alert, at the bottom of the Dialog, not in a toast.
    const response = await apiCancelSubscription();
    const account = await deserializer.deserialize(response);

    setAccount(account);
  }, []);

  const resumeSubscription = useCallback(async () => {
    setIsSubmitting(true);

    try {
      const response = await apiResumeSubscription();
      const account = await deserializer.deserialize(response);

      setAccount(account);
      toast.success(SUCCESS_MESSAGES.subscription.resume);
    } catch (error) {
      toast.error(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  useEffect(() => {
    const fetchAccount = async () => {
      setIsLoading(true);

      try {
        const response = await apiFetchAccount();
        const account = await deserializer.deserialize(response);

        setAccount(account);
      } catch (error) {
        toast.error(error.message);
        Honeybadger.notify(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAccount();
  }, []);

  return { account, cancelSubscription, isLoading, isSubmitting, resumeSubscription };
};

export default useBilling;
